// v2 campaign lane file — see app/v2/README.md. Owned by one build agent at a time;
// other agents and humans: do not edit. Routes here are HIDDEN (reachable only via
// /v2-screens and deep links) and every element must wrap in <RequireAuth>.
import { lazy, type ReactElement } from 'react';
import { Route } from 'react-router-dom';
import { RequireAuth } from '@/shared/auth/RequireAuth';

const InterfaceConsole2Page = lazy(
  () => import('@/features/interfaces/console2/InterfaceConsole2Page'),
);
const ItemMaster2Page = lazy(() => import('@/features/items/master2/ItemMaster2Page'));
const InterfaceServices2Page = lazy(
  () => import('@/features/interfaces/services2/InterfaceServices2Page'),
);
const LaborBoard2Page = lazy(() => import('@/features/labor/board2/LaborBoard2Page'));
const BillTransactions2Page = lazy(
  () => import('@/features/billing/transactions2/BillTransactions2Page'),
);
const Configuration2Page = lazy(
  () => import('@/features/config/configuration2/Configuration2Page'),
);
const ItemSearch2Page = lazy(() => import('@/features/items/search2/ItemSearch2Page'));
// Rank #48 merges three screens; two of the three live in features/warehouse (see
// router.tsx:394/399), so the page lives beside them even though its route is /admin/*.
const Automation2Page = lazy(() => import('@/features/warehouse/automation2/Automation2Page'));

export const slot5Routes: ReactElement[] = [
  <Route
    key="/interfaces/console2"
    path="/interfaces/console2"
    element={
      <RequireAuth>
        <InterfaceConsole2Page />
      </RequireAuth>
    }
  />,
  // Item Master v2 renders BOTH bare (the status2-style lookup card, so the /v2-screens
  // index can always link it) and keyed, exactly like /items/status2.
  <Route
    key="/items/master2"
    path="/items/master2"
    element={
      <RequireAuth>
        <ItemMaster2Page />
      </RequireAuth>
    }
  />,
  <Route
    key="/items/master2/:ownerId/:itemId"
    path="/items/master2/:ownerId/:itemId"
    element={
      <RequireAuth>
        <ItemMaster2Page />
      </RequireAuth>
    }
  />,
  <Route
    key="/interfaces/services2"
    path="/interfaces/services2"
    element={
      <RequireAuth>
        <InterfaceServices2Page />
      </RequireAuth>
    }
  />,
  <Route
    key="/labor/board2"
    path="/labor/board2"
    element={
      <RequireAuth>
        <LaborBoard2Page />
      </RequireAuth>
    }
  />,
  <Route
    key="/billing/transactions2"
    path="/billing/transactions2"
    element={
      <RequireAuth>
        <BillTransactions2Page />
      </RequireAuth>
    }
  />,
  // §4.23 MULTI-MODE WINDOW NAV RULE: PB w_configuration has TWO menu leaves and NO in-page
  // mode switcher, so the v2 gets two routes with the mode locked at launch — never a
  // toggle. The mode is a prop, not a URL param, so it cannot be re-scoped after mount.
  <Route
    key="/config/configuration2"
    path="/config/configuration2"
    element={
      <RequireAuth>
        <Configuration2Page mode="system" />
      </RequireAuth>
    }
  />,
  <Route
    key="/config/configuration-user2"
    path="/config/configuration-user2"
    element={
      <RequireAuth>
        <Configuration2Page mode="user" />
      </RequireAuth>
    }
  />,
  <Route
    key="/items/search2"
    path="/items/search2"
    element={
      <RequireAuth>
        <ItemSearch2Page />
      </RequireAuth>
    }
  />,
  <Route
    key="/admin/automation2"
    path="/admin/automation2"
    element={
      <RequireAuth>
        <Automation2Page />
      </RequireAuth>
    }
  />,
];
